import { Injectable } from '@angular/core';

@Injectable()
export class BackofficeGalleryService {

  private _imgsSrc : string[] = [];
  private _selectedIndex : number = 0;

  constructor() { }

  get imgsSrc() : string[] {
    return this._imgsSrc;
  }

  set imgsSrc(data : string[]) {
    this._imgsSrc = data;
  }

  get selectedIndex() : number {
    return this._selectedIndex;
  }

  set selectedIndex(index : number) {
    this._selectedIndex = index;
  }
}
